import controller from './login-box.controller';

export default {
  bindings: {
    onReset: '&'
  },
  controller,
  template: require('./login-box.html')
};



// WEBPACK FOOTER //
// src/app/components/login-dialog/login-box/login-box.component.ts